import React, { useState, useEffect } from "react";
import {
  Box,
  Container,
  Stepper,
  Step,
  StepLabel,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";
// import { Box, Container } from "@mui/material";
import { Formik, Form } from "formik";
// import { useDispatch } from "react-redux";
import { updateProfile } from "../../../../core/redux/action/userProfile";

import FormInformation from "./Forms/FormInformation";
import MentorInformation from "./Forms/MentorInformation";
import WorkingExperience from "./Forms/WorkingExperience";

import RegisterSuccessMentor from "./RegisterSuccess";

import validationSchema from "./FormModel/validationSchema";
import mentorFormModel from "./FormModel/mentorFormModel";
import formInitialValues from "./FormModel/formInitialValues";

import { useDispatch, useSelector } from "react-redux";
import { getProfile } from "../../../../core/service/users.service";

import useStyles from "./styles";

const steps = [
  "Personal Information",
  "Mentor Information",
  "Working Experience",
];
const { formId, formField } = mentorFormModel;

function _renderStepContent(step) {
  switch (step) {
    case 0:
      return <FormInformation formField={formField} />;
    case 1:
      return <MentorInformation formField={formField} />;
    case 2:
      return <WorkingExperience formField={formField} />;
    default:
      return <>Not Found</>;
  }
}

export default function EditMentorPage() {
  const dispatch = useDispatch();

  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const currentValidationSchema = validationSchema[activeStep];
  const isLastStep = activeStep === steps.length - 1;

  const [user, setUser] = useState({});
  const [userData, setUserData] = useState(null);
  const { role, user: currentUser } = useSelector((state) => state.authReducer);
  const { id } = currentUser;

  useEffect(() => {
    getUserProfile(id);
    console.log("id => ", id);
  }, []);

  useEffect(() => {
    console.log("user => ", user);
  }, [user]);

  const getUserProfile = async (id) => {
    const data = await getProfile(id).then((res) => {
      console.log(res);
      mapValues(res);
    });
  };

  function _sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async function _submitForm(values, actions) {
    var formData = new FormData();

    for (const [key, value] of Object.entries(values)) {
      formData.append(key, value ? value : "");
    }
    //phd
    formData.append("role", 4);
    formData.append("user_id", id);
    dispatch(updateProfile(formData));

    await _sleep(1000);
    actions.setSubmitting(false);
    setActiveStep(activeStep + 1);
  }

  function _handleSubmit(values, actions) {
    if (isLastStep) {
      _submitForm(values, actions);
    } else {
      setActiveStep(activeStep + 1);
      actions.setTouched({});
      actions.setSubmitting(false);
    }
  }

  function _handleBack() {
    setActiveStep(activeStep - 1);
  }
  const mapValues = (data) => {
    const formValues = formInitialValues;
    
    formValues.email = data?.email;
    formValues.academicTitle = data?.personal_infomation?.academic_title;
    formValues.nameEng = data?.personal_infomation?.name_en;
    formValues.middleNameEng = data?.personal_infomation?.middle_name_en;
    formValues.surnameEng = data?.personal_infomation?.surname_en;
    formValues.titleNameThai = data?.personal_infomation?.title_name_th;
    formValues.nameThai = data?.personal_infomation?.name_th;
    formValues.middleNameThai = data?.personal_infomation?.middle_name_th;
    formValues.surnameThai = data?.personal_infomation?.surname_th;

    formValues.faculty = data?.mentor_information?.faculty
    formValues.department = data?.mentor_information?.department
    formValues.mobileNumber = data?.mentor_information?.mobile_number
    formValues.dateOfBirth = data?.personal_infomation?.birth_date

    formValues.postdocFellowshipRecieve = data?.mentor_working_experience.postdoc_fellowship_recieve
    formValues.typeAllPostdocs = data?.mentor_working_experience.type_all_postdocs
    formValues.postdocCurrently = data?.mentor_working_experience.postdoc_currently
    formValues.postdocUnderSupervision = data?.mentor_working_experience.postdoc_under_supervision
    formValues.resignedPostdoc = data?.mentor_working_experience.resigned_postdoc
    formValues.phdScholarship = data?.mentor_working_experience.phd_scholarship
    formValues.allPhDStudents = data?.mentor_working_experience.all_phd_students
    formValues.phdStudents = data?.mentor_working_experience.phd_students
    formValues.studentUnderSupervision = data?.mentor_working_experience.student_under_supervision
    formValues.resignedStudent = data?.mentor_working_experience.resigned_student

    // console.log("formValues => ", formValues);

    setUserData(formValues);
  };
  return (
    <Container>
      <Box sx={{ textAlign: "center" }}>
        <>
          <Typography component="h1" variant="h4" align="center">
            Update for C2F Mentor
          </Typography>
          <Stepper activeStep={activeStep} className={classes.stepper}>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <>
            {activeStep === steps.length ? (
              <RegisterSuccessMentor />
            ) : (
              <Formik
                initialValues={formInitialValues}
                validationSchema={currentValidationSchema}
                onSubmit={_handleSubmit}
              >
                {({ isSubmitting }) => {
                  return (
                    <Form id={formId}>
                      {_renderStepContent(activeStep)}

                      <div className={classes.buttons}>
                        {activeStep !== 0 && (
                          <Button
                            onClick={_handleBack}
                            className={classes.button}
                          >
                            Back
                          </Button>
                        )}
                        <div className={classes.wrapper}>
                          <Button
                            disabled={isSubmitting}
                            type="submit"
                            variant="contained"
                            color="primary"
                            className={classes.button}
                          >
                            {isLastStep ? "Submit" : "Next"}
                          </Button>
                          {isSubmitting && (
                            <CircularProgress
                              size={24}
                              className={classes.buttonProgress}
                            />
                          )}
                        </div>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            )}
          </>
        </>
      </Box>
    </Container>
  );
}
